import { render, staticRenderFns } from "./ClienteForm.vue?vue&type=template&id=6dccc9b2&scoped=true&"
import script from "./ClienteForm.js?vue&type=script&lang=js&"
export * from "./ClienteForm.js?vue&type=script&lang=js&"
import style0 from "./ClienteForm.vue?vue&type=style&index=0&id=6dccc9b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dccc9b2",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QSelect,QIcon,QChip,QTable});
